<template>
	<a
		class="site_button"
		:class="[theme, type]"
		:href="parsedLink ? parsedLink.url : null"
		:target="parsedLink ? parsedLink.target : null"
		@mouseenter="hovered = true"
		@mouseleave="hovered = false"
		ref="site_button"
	>
		<video-icon
			class="video_icon"
			v-if="type === 'video'"
		></video-icon>

		<span v-html="button_label ? button_label : parsedLink.title"></span>

		<external-link
			class="external_link_icon"
			v-if="
        parsedLink.target === '_blank' ||
        button_link.target === '_blank' ||
        target === '_blank'
      "
		></external-link>

	</a>
</template>

<script>
import ExternalLink from './ExternalLink.vue';
import VideoIcon from './VideoIcon.vue';
export default {
	data() {
		return {
			button_label: this.label,
			button_link: this.link,
			hovered: false,
		};
	},

	props: {
		link: {},
		label: {},
		target: {},
		theme: {},
		type: {
			default: 'normal',
		},
	},

	computed: {
		parsedLink() {
			if (typeof this.link === 'object' && this.link !== null) {
				return this.link;
			} else if (!Array.isArray(this.link)) {
				try {
					return JSON.parse(this.link);
				} catch (e) {
					return null;
				}
			} else {
				return null;
			}
		},
	},

	watch: {
		link() {
			this.button_link = this.link;
		},
	},

	methods: {
		checkEmpty(e) {
			if (this.button_link.url === '#') {
				// this.$refs.site_button.removeAttribute('href');
				e.preventDefault();
			}
		},
	},

	components: { ExternalLink, VideoIcon },

	created() {},
	mounted() {},
};
</script>

<style lang="scss" scoped>
@import '../../styles/common/variables';

.site_button {
	display: inline-flex;
	padding: 0 16px;
	/* border: 1px solid var(--white); */
	border-radius: 30px;
	background: transparent;
	text-decoration: none;
	height: 34px;
	display: inline-flex;
	justify-content: center;
	align-items: center;
	transition: 0.2s ease all;
	color: var(--white);
	background: var(--cobalt);

	&.reverse {
		background: var(--white);
		color: var(--midnight);

		span {
			color: var(--midnight);
		}

		svg {
			display: flex;

			&::v-deep {
				path {
					stroke: var(--midnight);
				}
			}
		}

		@media (hover) {
			&:hover {
				background: var(--midnight);
				transition: 0.2s ease all;
				cursor: pointer;
				color: var(--white);

				span {
					color: var(--white);
				}

				svg {
					display: flex;

					&::v-deep {
						path {
							stroke: var(--white);
						}
					}
				}
			}
		}
	}

	&.current {
		background: var(--cobalt);
		transition: 0.2s ease all;
		cursor: pointer;
		color: var(--white);
	}

	.video_icon {
		margin-right: 7px;
	}

	.external_link_icon {
		margin-left: 8px;

		line,
		path {
			stroke: var(--white);
			transition: 0.2s ease all;

			g {
				stroke: var(--white);
				transition: 0.2s ease all;
			}
		}
	}

	@media (hover) {
		&:hover {
			background: var(--midnight);
			transition: 0.2s ease all;
			cursor: pointer;
			color: var(--white);
		}
	}

	&:disabled {
		opacity: 0.5;
	}

	span {
		font: normal normal 600 15px/18px var(--primary-font-family);
		color: var(--white);
		margin-right: 0;
		position: relative;
		z-index: 10;
		margin-top: 2px;
	}

	svg {
		display: flex;

		&::v-deep {
			path {
				stroke: var(--white);
			}
		}
	}
}
</style>
